/**
 * Go Sport - Bibliothèque de mouvements HIIT par niveau
 */

export const EXERCISES = {
  // Niveaux 1-2 : Débutants
  beginner: [
    { id: 'march', name: 'Marche sur place', zone: ['full', 'cardio'], tip: 'Gardez le dos droit, levez bien les genoux' },
    { id: 'slow_knees', name: 'Montées de genoux lentes', zone: ['cardio', 'lower'], tip: 'Rythme régulier, respirez' },
    { id: 'bodyweight_squat', name: 'Squats au poids du corps', zone: ['lower', 'full'], tip: 'Genoux derrière les orteils, descendez doucement' },
    { id: 'knee_pushup', name: 'Pompes sur les genoux', zone: ['upper', 'full'], tip: 'Gardez le corps aligné, contrôlez la descente' },
    { id: 'static_plank', name: 'Planche statique (10s)', zone: ['full', 'upper'], tip: 'Serrez les abdos, ne creusez pas le dos' },
    { id: 'slow_lunges', name: 'Fentes avant alternées', zone: ['lower', 'full'], tip: 'Pas contrôlé, genou à 90°' },
    { id: 'slow_jacks', name: 'Jumping jacks lents', zone: ['cardio', 'full'], tip: 'Mouvements amples, à votre rythme' },
    { id: 'shoulder_rotation', name: 'Rotation des épaules', zone: ['upper'], tip: 'Grands cercles, alternez le sens' },
  ],

  // Niveaux 3-4 : Intermédiaires débutants
  intermediate_beginner: [
    { id: 'jumping_jacks', name: 'Jumping jacks', zone: ['cardio', 'full'], tip: 'Bras tendus, rythme soutenu' },
    { id: 'soft_squat_jump', name: 'Squats sautés (doux)', zone: ['lower', 'full'], tip: 'Atterrissez en souplesse' },
    { id: 'burpee_no_jump', name: 'Burpees sans saut', zone: ['full'], tip: 'Posez les mains, reculez les pieds, revenez' },
    { id: 'dynamic_plank', name: 'Planche dynamique', zone: ['full', 'upper'], tip: 'Alternez bras tendus et coudes' },
    { id: 'slow_climbers', name: 'Mountain climbers lents', zone: ['full', 'cardio'], tip: 'Genou vers poitrine, alternez' },
    { id: 'alt_jump_lunges', name: 'Fentes sautées alternées', zone: ['lower', 'full'], tip: "Contrôlez l'atterrissage" },
    { id: 'classic_pushup', name: 'Pompes classiques', zone: ['upper', 'full'], tip: 'Corps gainé, descente contrôlée' },
    { id: 'step_touches', name: 'Step touches', zone: ['cardio', 'lower'], tip: 'Restez léger sur vos pieds' },
  ],

  // Niveaux 5-6 : Intermédiaires
  intermediate: [
    { id: 'full_burpee', name: 'Burpees complets', zone: ['full', 'cardio'], tip: 'Explosif sur le saut, gainé en planche' },
    { id: 'fast_climbers', name: 'Mountain climbers rapides', zone: ['full', 'cardio'], tip: 'Rythme rapide, hanches basses' },
    { id: 'high_knees', name: 'High knees', zone: ['cardio', 'lower'], tip: 'Genoux hauts, bras opposés' },
    { id: 'squat_jumps', name: 'Squat jumps', zone: ['lower', 'full'], tip: 'Explosez vers le haut, amortissez' },
    { id: 'clap_pushup', name: 'Pompes avec claquement', zone: ['upper', 'full'], tip: 'Poussée explosive, réception souple' },
    { id: 'sprint_place', name: 'Sprints sur place', zone: ['cardio'], tip: 'Vitesse maximale, bras actifs' },
    { id: 'box_jumps', name: 'Box jumps (chaise)', zone: ['lower', 'full'], tip: 'Atterrissez en douceur, 2 pieds' },
    { id: 'plank_shoulder_tap', name: 'Planche avec tap épaule', zone: ['full', 'upper'], tip: 'Minimisez la rotation du bassin' },
  ],

  // Niveaux 7-8 : Avancés
  advanced: [
    { id: 'burpee_pullup', name: 'Burpees avec pull-up', zone: ['full'], tip: 'Enchaînez burpee + traction' },
    { id: 'double_unders', name: 'Double unders (corde)', zone: ['cardio', 'full'], tip: 'Poignets souples, saut haut' },
    { id: 'pistol_squat', name: 'Pistol squats', zone: ['lower'], tip: 'Jambe tendue devant, descendez' },
    { id: 'hspu', name: 'Handstand push-ups (mur)', zone: ['upper'], tip: 'Tête au sol, poussée explosive' },
    { id: 'thruster', name: 'Thruster (haltères)', zone: ['full', 'upper'], tip: 'Squat + développé en un mouvement' },
    { id: 'high_box_jumps', name: 'Box jumps hauts', zone: ['lower', 'full'], tip: 'Hauteur max, contrôlez la descente' },
    { id: 'man_makers', name: 'Man makers', zone: ['full'], tip: 'Pompe + row + squat + press' },
    { id: 'bear_crawl', name: 'Bear crawl', zone: ['full', 'upper'], tip: 'Genoux bas, déplacement rapide' },
  ],

  // Niveaux 9-10 : Élite
  elite: [
    { id: 'clean_jerk', name: 'Clean & jerk', zone: ['full'], tip: 'Technique avant charge' },
    { id: 'snatch', name: 'Snatch', zone: ['full'], tip: 'Tirage explosif, réception stable' },
    { id: 'muscle_ups', name: 'Muscle-ups', zone: ['upper', 'full'], tip: 'Traction + transition + dip' },
    { id: 'assault_bike', name: 'Assault bike sprints', zone: ['cardio', 'full'], tip: 'Effort maximal, bras + jambes' },
    { id: 'turkish_getup', name: 'Turkish get-up', zone: ['full'], tip: 'Mouvement lent et contrôlé' },
    { id: 'sled_push', name: 'Sled push simulation', zone: ['lower', 'full'], tip: 'Poussée basse, jambes puissantes' },
    { id: 'tabata_full', name: 'Tabata intervals full body', zone: ['full', 'cardio'], tip: '20s max / 10s repos × 8' },
    { id: 'complex_barbell', name: 'Complex barbell', zone: ['full'], tip: 'Enchaînez sans poser la barre' },
  ],
};

export const STRETCHES = [
  { name: 'Étirement ischio-jambiers', duration: '30s chaque jambe', muscle: 'Arrière des cuisses' },
  { name: 'Pigeon (yoga)', duration: '45s chaque côté', muscle: 'Hanches / Fessiers' },
  { name: 'Chat-vache', duration: '8 répétitions', muscle: 'Colonne vertébrale' },
  { name: 'Étirement pectoraux au mur', duration: '30s chaque côté', muscle: 'Poitrine / Épaules' },
  { name: 'Étirement cervicaux', duration: '20s × 4 directions', muscle: 'Cou' },
  { name: "Child's pose", duration: '1 min', muscle: 'Dos / Épaules' },
  { name: 'Cobra', duration: '30s × 2', muscle: 'Abdominaux / Dos' },
  { name: 'Respiration cohérence cardiaque', duration: '2 min', muscle: 'Récupération cardiaque' },
];

export function getExercisesForLevel(level) {
  if (level <= 2) return EXERCISES.beginner;
  if (level <= 4) return EXERCISES.intermediate_beginner;
  if (level <= 6) return EXERCISES.intermediate;
  if (level <= 8) return EXERCISES.advanced;
  return EXERCISES.elite;
}

export function generateSession(level, bodyZone, exerciseCount = 8) {
  const pool = getExercisesForLevel(level);
  let filtered = bodyZone === 'full'
    ? pool
    : pool.filter(ex => ex.zone.includes(bodyZone));

  if (filtered.length < exerciseCount) filtered = pool;

  const shuffled = [...filtered].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, Math.min(exerciseCount, shuffled.length));
}
